<template>
  <canvas ref="canvas" class="editor-canvas" />
</template>

<script>
import {
  scale,
  rotateDEG,
  translate,
  compose,
  applyToPoint,
  inverse
} from "transformation-matrix";

export default {
  props: {
    transformations: Object,
    image: String,
    frameSize: Array,
  },
  data() {
    return {
      domImage: null,
      ctx: null,
      lastMatrix: null,

      canvasWidth: 968,
      canvasHeight: 387,

      imageSize: {
        x: 0,
        y: 0,
      },
    };
  },
  watch: {
    image() {
      this.updateImage();
    },
    transformations: {
      deep: true,
      handler() {
        this.redraw();

        this.emitPresenationParams();
      },
    },
  },
  methods: {
    getImageSize() {
      return this.imageSize;
    },
    emitPresenationParams() {
      this.$emit(
        "present",
        this.computePresentation(
          this.transformations.translate_x,
          this.transformations.translate_y,
          this.transformations.zoom,
          this.transformations.rotate
        )
      );
    },
    computeMatrix(tx, ty, zoom, rotation, iw, ih) {
      return compose(
        translate(this.canvasWidth / 2, this.canvasHeight / 2),
        scale(zoom, zoom),
        translate(-this.canvasWidth / 2, -this.canvasHeight / 2),

        translate(tx, ty),
        
        // translate((iw || this.imageSize.x) / 2, (ih || this.imageSize.y) / 2),
        // rotateDEG(rotation),
        // translate(-(iw || this.imageSize.x) / 2, -(ih || this.imageSize.y) / 2)
      );
    },
    computeInverseMatrix(tx, ty, zoom, rotation, iw, ih) {
      // return inverse(this.computeMatrix(
      //   tx,
      //   ty,
      //   zoom,
      //   rotation
      // ));
      return inverse(
        compose(
          translate(this.canvasWidth / 2, this.canvasHeight / 2),
          scale(zoom, zoom),
          translate(-this.canvasWidth / 2, -this.canvasHeight / 2),
        )
      );
      // return compose(
      //   // translate((iw || this.imageSize.x) / 2, (ih || this.imageSize.y) / 2),
      //   // rotateDEG(360-rotation),
      //   // translate(-(iw || this.imageSize.x) / 2, -(ih || this.imageSize.y) / 2),

      //   translate(-tx, -ty),

      //   translate(this.canvasWidth / 2, this.canvasHeight / 2),
      //   scale(1/zoom, 1/zoom),
      //   translate(-this.canvasWidth / 2, -this.canvasHeight / 2),
      // );
    },
    computePresentation(tx, ty, zoom, rotation) {
      // console.log(`[EditorCanvas] Presenting for ${tx}, ${ty}, ${zoom}, ${rotation}`)  
      const base = {
        full_width: this.imageSize.x,
        full_height: this.imageSize.y,
        x: tx,
        y: ty,

        frame_x: this.framePosition.x,
        frame_y: this.framePosition.y,
        frame_width: this.frameSize[0],
        frame_height: this.frameSize[1],
      };

      let matrix = this.computeMatrix(  
        tx,ty, zoom, rotation
      );

      const real_pos = applyToPoint(matrix, {
        x: 0,
        y: 0,
      });

      const corner_pos = applyToPoint(matrix, {
        x: this.imageSize.x,
        y: this.imageSize.y 
      })

      base.present_x = real_pos.x;
      base.present_y = real_pos.y;

      base.corner_x = corner_pos.x;
      base.corner_y = corner_pos.y;

      base.present_width = Math.abs(corner_pos.x - real_pos.x);
      base.present_height = Math.abs(corner_pos.y - real_pos.y);

      base.first_x = real_pos.x;
      base.first_y = real_pos.y;

      base.present_x = Math.min(real_pos.x, corner_pos.x);
      base.present_y = Math.min(real_pos.y, corner_pos.y);
      return base;
    },
    updateImage() {
      this.domImage = new Image();

      this.domImage.src = this.image;

      this.domImage.onload = () => {
        const ratio = this.domImage.naturalWidth / this.domImage.naturalHeight; 

        this.imageSize.x = this.canvasWidth;
        this.imageSize.y = this.canvasWidth / ratio;
        this.emitPresenationParams();
        this.redraw();
        this.$nextTick(() => {
          this.$emit('imageUpdated')
        });
      };
    },
    initCanvas() {
      const canvas = this.$refs.canvas;
      canvas.width = this.canvasWidth;
      canvas.height = this.canvasHeight;

      this.ctx = canvas.getContext("2d");
      this.redraw();
    },
    drawImage() {
      //draw image itself
      if (this.domImage) {
        this.ctx.save();
        const imageX = this.transformations.translate_x;
        const imageY = this.transformations.translate_y;

        //zooming
        this.ctx.translate(this.canvasWidth / 2, this.canvasHeight / 2);
        this.ctx.scale(this.transformations.zoom, this.transformations.zoom);
        this.ctx.translate(-this.canvasWidth / 2, -this.canvasHeight / 2);

        //  this.ctx.translate(imageX, imageY); 
        
        // this.ctx.translate(this.imageSize.x / 2, this.imageSize.y / 2);
        // this.ctx.rotate((this.transformations.rotate * Math.PI) / 180);
        // this.ctx.translate(-this.imageSize.x / 2, -this.imageSize.y / 2);
        // const matrix = this.computeMatrix(
        //   imageX,
        //   imageY,
        //   this.transformations.zoom,
        //   0
        // );

        // this.ctx.setTransform(matrix.a, matrix.b, matrix.c, matrix.d, matrix.e, matrix.f);

        this.ctx.drawImage( 
          this.domImage,
          imageX,
          imageY,
          this.imageSize.x,
          this.imageSize.y
        );

        this.lastMatrix = this.ctx.getTransform();  

        this.ctx.restore();
      }
    },
    getLastMatrix() {
      return this.lastMatrix;
    },  
    redraw() {
      //clear
      this.ctx.fillStyle = '#ffffff';
      this.ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
      this.ctx.fillStyle = "rgba(0,0,0,0.52)";
      this.ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);

      this.ctx.fillStyle = '#ffffff';

      this.drawImage();

      const canvasCenterX = this.canvasWidth / 2;
      const canvasCenterY = this.canvasHeight / 2;

      //draw crop frame
      const frameWidth = this.frameSize[0];
      const frameHeight = this.frameSize[1];

      const frameX = Math.round(canvasCenterX - frameWidth / 2);
      const frameY = Math.round(canvasCenterY - frameHeight / 2);

      //draw backdrop overlay
      this.ctx.fillStyle = "rgba(0,0,0,0.52)";

      //top
      this.ctx.fillRect(0, 0, this.canvasWidth, frameY);

      //bottom
      this.ctx.fillRect(
        0,
        frameY + frameHeight,
        this.canvasWidth,
        frameY + frameHeight
      );

      //left
      this.ctx.fillRect(0, frameY, frameX, frameHeight);

      //right
      this.ctx.fillRect(
        frameX + frameWidth,
        frameY,
        this.canvasWidth,
        frameHeight
      );

      //crop frame
      this.ctx.strokeStyle = "#ffffff";
      this.ctx.strokeRect(frameX, frameY, frameWidth, frameHeight);

      this.emitPresenationParams();
    },
  },
  computed: {
    canvasCenter() {
      return {
        x: this.canvasWidth / 2,
        y: this.canvasHeight / 2,
      };
    },
    framePosition() {
      return {
        x: this.canvasCenter.x - this.frameSize[0] / 2,
        y: this.canvasCenter.y - this.frameSize[1] / 2,
      };
    },
  },
  mounted() {
    this.initCanvas();
    this.updateImage();
  },
};
</script>

<style scoped>
.editor-canvas {
  cursor: grab;
  position:relative;
  z-index: 5000;
  border-radius: 6px;
}
</style>